/** Service (waiter) copy. Floor and order entry copy is shared in `order.ts`. */
export const enPelayan = {
  'pelayan.nav.tables': 'Tables',
  'pelayan.floor.subtitle': 'Pick a table to take orders; serve what the kitchen marked ready.',
  'pelayan.ready.title': 'Ready to serve',
  'pelayan.ready.description': 'Items the kitchen has marked ready, by table.',
  'pelayan.ready.empty': 'Nothing ready yet — items appear when the kitchen marks them ready.',
  'pelayan.ready.serveAll': 'Mark all served',
  'pelayan.takeaway.title': 'Takeaway',
  'pelayan.takeaway.description': 'Open takeaway orders — tap one to add items or serve.',
  'pelayan.takeaway.empty': 'No open takeaway orders.',
  'pelayan.takeaway.items': '{count} items',
  'pelayan.order.back': 'Back to tables',
  'pelayan.order.number': 'Order {number}',
  'pelayan.order.closedNote': 'This order is paid and closed.',
  'pelayan.order.cancelledNote': 'This order was cancelled.',
} as const;
